<template>
  <IconButton
    :icon="iconProperties.icon"
    :color="iconProperties.color"
    :tooltip="iconProperties.tooltip"
    :loading="processing"
    float
    @click="click"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    reserveDate: {
      type: Object,
      default: () => {}
    },
    rollingDate: {
      type: Object,
      default: () => {}
    },
    currentDatetime: {
      type: Object,
      default: () => {}
    },
    vehicleID: {
      type: String,
      default: '0'
    },
    vehicleInState: {
      type: Boolean,
      default: false
    },
    parkingAreaID: {
      type: String,
      default: ''
    },
    openDate: {
      type: Object,
      default: () => {}
    },
    closeDate: {
      type: Object,
      default: () => {}
    },
    capacity: {
      type: String,
      default: '0'
    },
    blackouts: {
      type: Object,
      default: () => {}
    },
    bookings: {
      type: Object,
      default: () => {}
    },
    utilization: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      reserver: false,
      processing: false
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'person/authenticated'
    }),
    unrestricted () {
      return this.assertSetting('miscReservationUnrestricted', 1)
    },
    booking () {
      return this.bookings?.[this.reserveDate.format('YYYY-MM-DD')]?.[this.vehicleID]
    },
    blackout () {
      return this.blackouts?.[this.reserveDate.format('YYYY-MM-DD')]
    },
    dayUtilization () {
      return this.utilization?.[this.reserveDate.format('YYYY-MM-DD')]?.utilization || 0
    },
    iconProperties () {
      if (this.booking) { // booked with current vehicle
        if (Number(this.booking.finalized)) { // booking finalized
          return {
            icon: 'fa-play',
            color: 'green',
            tooltip: 'You previously reserved this',
            action: null
          }
        } else { // in cart
          return {
            icon: 'fa-check',
            color: 'green',
            tooltip: 'This reservation is in your cart',
            action: this.remove
          }
        }
      } else if (Number(this.dayUtilization) >= Number(this.capacity)) { // dayUtilization
        return {
          icon: 'fa-times',
          color: 'red',
          tooltip: 'The Lot is full',
          action: null
        }
      } else if (this.blackout) {
        if (this.blackout.blackoutTypeWord === 'Offline Only') {
          if (this.unrestricted) { // admin
            return {
              icon: 'fa-plus',
              color: 'purple',
              tooltip: this.blackout.blackoutTypeWord,
              action: this.add
            }
          } else {
            return {
              icon: 'fa-phone',
              color: 'purple',
              tooltip: this.blackout.blackoutTypeWord,
              action: null
            }
          }
        } else {
          return {
            icon: 'fa-times',
            color: 'red',
            tooltip: this.blackout.blackoutTypeWord,
            action: null
          }
        }
      } else if (this.reserveDate.isBefore(this.openDate, 'day') || this.reserveDate.isAfter(this.closeDate, 'day') || this.reserveDate.isBefore(this.currentDatetime)) { // closed
        return {
          icon: 'fa-times',
          color: 'red',
          tooltip: 'Closed',
          action: null
        }
      } else if (!this.authenticated) { // not logged in
        return {
          icon: 'fa-question',
          color: 'orange',
          tooltip: 'Log in to check availability and reserve',
          action: null
        }
      } else if (!this.vehicleID) { // no vehicle selected
        return {
          icon: 'fa-question',
          color: 'orange',
          tooltip: this.capacity - this.dayUtilization + ' spots left. Select a vehicle above to see availability.',
          action: null
        }
      } else if (this.reserveDate.isAfter(this.rollingDate, 'day') && !this.vehicleInState) { // past rolling date
        if (this.unrestricted) { // admin
          return {
            icon: 'fa-plus',
            color: 'purple',
            tooltip: this.capacity - this.dayUtilization + ' spots left. Not available for non-residents yet',
            action: this.add
          }
        } else {
          return {
            icon: 'fa-calendar',
            color: 'orange',
            tooltip: this.capacity - this.dayUtilization + ' spots left. Not available for online reservations yet',
            action: null
          }
        }
      } else { // good to reserve
        return {
          icon: 'fa-plus',
          color: 'blue',
          tooltip: this.capacity - this.dayUtilization + ' spots left. Click to reserve',
          action: this.add
        }
      }
    }
  },
  methods: {
    ...mapActions({
      getParkingWeek: 'facilities/getParkingWeek',
      createParkingBooking: 'cart/createParkingBooking',
      deleteParkingBooking: 'cart/deleteParkingBooking',
      newNotification: 'info/newNotification'
    }),
    click () {
      if (this.iconProperties.action) {
        this.processing = true
        this.iconProperties.action()
      }
    },
    add () {
      if (!this.authenticated) {
        this.newNotification({ message: 'You must be logged in to reserve.' })
      } else if (!this.assertSetting('parkingOpen', 1)) {
        this.newNotification({ message: 'Online parking reservations are currently closed. Please call the office to make a reservation.' })
      } else {
        this.createParkingBooking({ parkingAreaID: this.parkingAreaID, date: this.reserveDate.format('YYYY-MM-DD'), vehicleID: this.vehicleID }).finally(this.reload)
      }
    },
    remove (payload) {
      this.deleteParkingBooking({ parkingBookingID: this.booking.parkingBookingID }).finally(this.reload)
    },
    reload () {
      return this.getParkingWeek().finally(() => {
        this.processing = false
      })
    }
  }
}
</script>
